import PropTypes from "prop-types";
import React, { Fragment } from "react";
import styles from "./feeds-seo-faq.css";

function FeedsSeoFaq({ faq }) {
    return (
        <div className={styles.faq}>
            <h3>{faq.title}</h3>
            <dl>
                {faq.items.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <dt className={styles.faqTitle}>{item.title}</dt>
                            <dd className={styles.faqText}>{item.body}</dd>
                        </Fragment>
                    );
                })}
            </dl>
        </div>
    );
}

FeedsSeoFaq.propTypes = {
    faq: PropTypes.object,
};

export default FeedsSeoFaq;
